import { TeamsRecipientInfo, TeamsRecipientType } from './types';

export const DEAL_ROOM_OPTION: TeamsRecipientInfo = {
  id: 'deal_room',
  label: "Record's deal room",
  type: TeamsRecipientType.CHANNEL_STORED_IN_SWEEP,
};
